'use strict'

module.exports = require('./globalthis').TextEncoder
